/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DiscountInputs */

const en_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount`)
};

const th_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่วนลด`)
};

const ja_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割引`)
};

const fr_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remise`)
};

const es_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuento`)
};

const ru_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скидка`)
};

const zh_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`折扣`)
};

const vi_discount = /** @type {(inputs: DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá`)
};

/**
* | output |
* | --- |
* | "Discount" |
*
* @param {DiscountInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const discount = /** @type {((inputs?: DiscountInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DiscountInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_discount(inputs)
	if (locale === "ja") return ja_discount(inputs)
	if (locale === "fr") return fr_discount(inputs)
	if (locale === "es") return es_discount(inputs)
	if (locale === "ru") return ru_discount(inputs)
	if (locale === "zh") return zh_discount(inputs)
	if (locale === "vi") return vi_discount(inputs)
	return en_discount(inputs)
});